import { render, staticRenderFns } from "./querSuHighvalueList.vue?vue&type=template&id=42bd14b3&scoped=true"
import script from "./querSuHighvalueList.vue?vue&type=script&lang=js"
export * from "./querSuHighvalueList.vue?vue&type=script&lang=js"
import style0 from "./querSuHighvalueList.vue?vue&type=style&index=0&id=42bd14b3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42bd14b3",
  null
  
)

export default component.exports